// extracted by mini-css-extract-plugin
export default {"blog":"Blog_blog__5vXKH"};